export default "__VITE_ASSET__jLBThrH5__"